/**
 * @module mapbs.components.wfsservice.wfsservice
 */

import angular from 'angular';

import olFeature from 'ol/Feature.js'; // eslint-disable-line no-unused-vars
import * as olFormatFilter from 'ol/format/filter.js';
import olFormatFilterAnd from 'ol/format/filter/And.js'; // eslint-disable-line no-unused-vars
import olFormatFilterEqualTo from 'ol/format/filter/EqualTo.js';
import olFormatWFS from 'ol/format/WFS.js';
import olGeomGeometry from 'ol/geom/Geometry.js'; // eslint-disable-line no-unused-vars
import olGeomPoint from 'ol/geom/Point.js'; // eslint-disable-line no-unused-vars
import olGeomPolygon from 'ol/geom/Polygon.js'; // eslint-disable-line no-unused-vars

const moduleWfsservice = angular.module('mapbsWfsServiceModule', []);

class WfsService {
    /**
   * @constructor
   * @param {angular.$injector} $injector
   * @param {angular.$http} $http
   * @param {angular.$q} $q
   * @ngInject
   */
    constructor($injector, $http, $q) {
    /**
     * @type {angular.$http}
     * @private
     */
        this.http = $http;

        /**
     * @type {angular.$q}
     * @private
     */
        this.q = $q;

        /**
     * @type {string}
     * @private
     */
        this.wfsUrl = $injector.get('mapserverUrl');
    }

    /**
   * @param {olGeomPoint} coord
   * @param {Array<string>} featuresList
   * @param {?number} boundingBoxSize
   * @return {angular.$q.Promise<Array<olFeature>>}
   */
    getFeatureByCoord(coord, featuresList, boundingBoxSize = 1) {
        const boundingBox = this.getBoundingboxBySize(coord, boundingBoxSize);

        if (!featuresList) {
            featuresList = [];
        }

        const featureRequest = new olFormatWFS().writeGetFeature({
            featurePrefix: 'osm',
            featureNS: 'https://map.geo.bs.ch',
            featureTypes: featuresList,
            geometryName: 'the_geom',
            bbox: boundingBox,
        });

        return this.getWfsFeatures(featureRequest);
    }

    /**
   * @param {olGeomPolygon} geom
   * @param {Array<string>} featureList
   * @return {angular.$q.Promise<Array<olFeature>>}
   */
    getFeatureByPolygon(geom, featureList) {
        const featureRequest = new olFormatWFS().writeGetFeature({
            featurePrefix: 'osm',
            featureNS: 'http://map.geo.bs.ch',
            featureTypes: featureList,
            filter: olFormatFilter.intersects(
                'the_geom',
                /** @type {!olGeomGeometry} */ (geom),
                'EPSG:2056'
            ),
        });

        return this.getWfsFeatures(featureRequest);
    }

    /**
   * @param {?string} propertyname
   * @param {?string} filtervalue
   * @param {Array<string>} featureList
   * @return {angular.$q.Promise<Array<olFeature>>}
   */
    getFeatureByFilter(propertyname, filtervalue, featureList) {
        const featureRequest = new olFormatWFS().writeGetFeature({
            featurePrefix: 'osm',
            featureNS: 'https://map.geo.bs.ch',
            featureTypes: featureList,
            filter: new olFormatFilterEqualTo(propertyname, filtervalue, false),
        });

        return this.getWfsFeatures(featureRequest);
    }

    /**
   * @param {Array<string>} featureList
   * @param {? | olFormatFilterAnd | olFormatFilterEqualTo} fi
   * @return {angular.$q.Promise<Array<olFeature>>}
   */
    getFeatureByOlFilter(featureList, fi) {
        const featureRequest = new olFormatWFS().writeGetFeature({
            featurePrefix: 'osm',
            featureNS: 'https://map.geo.bs.ch',
            featureTypes: featureList,
            filter: fi,
        });

        return this.getWfsFeatures(featureRequest);
    }

    /**
   * @param {olGeomGeometry} point
   * @param {number} boundingBoxSize
   * @private
   */
    getBoundingboxBySize(point, boundingBoxSize) {
        const extent = point.getExtent();
        const boundingBox = [];
        boundingBox.push(extent[0] - boundingBoxSize / 2);
        boundingBox.push(extent[1] - boundingBoxSize / 2);
        boundingBox.push(extent[2] + boundingBoxSize / 2);
        boundingBox.push(extent[3] + boundingBoxSize / 2);

        return boundingBox;
    }

    /**
   * @param {olFormatWFS} wfsRequest
   * @return {angular.$q.Promise<Array<olFeature>>}
   * @private
   */
    getWfsFeatures(wfsRequest) {
        const body = new XMLSerializer().serializeToString(wfsRequest);
        const params = {};
        const headers = {'Content-Type': 'text/xml; charset=UTF-8'};

        return this.http
      .post(this.wfsUrl, body, {params, headers})
      .then((response) => {
          return new olFormatWFS().readFeatures(response.data);
      });
    }
}

moduleWfsservice.service('mapbsWfsService', WfsService);

export default moduleWfsservice;
